import React from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

interface NonInbodyNoticeProps {
  /** 캐시를 비우고 계정 선택 화면으로 다시 로그인시키는 핸들러 */
  onSwitchAccount: () => void;
}

/**
 * 타 도메인(비 @inbody.com) 계정으로 접속한 경우 노출되는 안내 카드.
 * 흔한 원인은 KOROT 등 다른 계정이 캐시에 남아 차단되는 경우이므로,
 * 빈 화면 대신 안내 문구와 함께 '다른 계정으로 로그인' 경로를 제공한다.
 */
function NonInbodyNotice({
  onSwitchAccount,
}: NonInbodyNoticeProps): React.ReactElement {
  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <LockOutlinedIcon style={styles.icon} />
        <h2 style={styles.title}>이용할 수 없는 계정입니다</h2>
        <p style={styles.desc}>
          InBody 임직원(@inbody.com) 계정으로만 예약 시스템을 이용할 수 있습니다.
          <br />
          접속하신 계정으로는 이용이 불가능합니다.
        </p>
        <div style={styles.notice}>
          지사 또는 자회사의 경우,
          <br />
          <b>예약 사이트용 공용 계정</b>으로 로그인하여 이용 바랍니다.
        </div>
        <button type="button" style={styles.button} onClick={onSwitchAccount}>
          다른 계정으로 로그인
        </button>
      </div>
    </div>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  overlay: {
    position: "fixed",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f5f6f8",
    padding: 20,
    zIndex: 9999,
  },
  card: {
    width: "100%",
    maxWidth: 420,
    background: "#ffffff",
    borderRadius: 16,
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.08)",
    padding: "40px 32px",
    textAlign: "center",
    boxSizing: "border-box",
  },
  icon: {
    fontSize: 48,
    color: "#2f6df6",
    marginBottom: 12,
  },
  title: {
    margin: "0 0 16px",
    fontSize: 20,
    fontWeight: 700,
    color: "#1f2933",
  },
  desc: {
    margin: "0 0 20px",
    fontSize: 14,
    lineHeight: 1.7,
    color: "#52606d",
  },
  notice: {
    background: "#eef4ff",
    color: "#1c4fd6",
    borderRadius: 10,
    padding: "14px 16px",
    fontSize: 14,
    lineHeight: 1.6,
    marginBottom: 28,
  },
  button: {
    width: "100%",
    border: "none",
    borderRadius: 10,
    padding: "13px 0",
    fontSize: 15,
    fontWeight: 600,
    color: "#ffffff",
    background: "#2f6df6",
    cursor: "pointer",
  },
};

export default NonInbodyNotice;
